import script from "./DateTimeDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateTimeDisplay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__